import { createBusinessAddress } from "./actions/createNetworkAddress";
import { createPayinAddress } from "./actions/createPayinAddress";
import { updateBusinessAddress } from "./actions/updateNetworkAddress";

export const actions = {
    createBusinessAddress,
    createPayinAddress,
    updateBusinessAddress,
};